<template>
  <div v-show='data.hidden === false' class="col-sm-6 h-col-inputBoxSub">
    <div class='h-subscriber-inputLit' v-if="data.showName !== ''">
      <span v-show="getRequired" class="h-red-code">* </span>
      {{data.showName}}
    </div>
    <div>
      <ejs-datepicker :format='dateFormat' :readonly='data.readonly' :disabled='data.disabled' :value='data.value' :name='data.name' v-model='params.paramVal'></ejs-datepicker>
    </div>
    <!--<button @click="getData">GetParam</button>-->
  </div>
</template>
<script>
import common from '../common';

export default {
  name: 'Son_Date',
  props: [
    'data',
    'opCode'
  ],
  mixins: [common],
  data() {
    return {
      params: {
        name: this.data.name,
        paramVal: this.data.value
      },
      dateFormat: 'yyyy-MM-dd',
      text: [
        'h-subscriber-inputBoxDiv',
        'h-subscriber-inputBoxDivInPartten1',
        'h-subscriber-inputBoxDivInPartten2'
      ],
    };
  },
  methods: {
    caculateRadioButton() {
      this.$refs.radioButton.forEach((item, index) => {
        if (item.ej2Instances.checked === true) {
          this.params.paramVal = this.data.options[index].value;
        }
      });
    },
    getData() {
      const _dateParamVal = this.params.paramVal.Format(this.dateFormat);
      return {
        name: this.params.name,
        paramVal: _dateParamVal
      }
    }
  },
  created() {
    this.$parseInitData();
  },
};
</script>

<style scoped>

</style>
